import {ChangeDetectionStrategy, Component, HostBinding, Input, OnInit} from '@angular/core';
import {GridContainerClass} from './container.class';

@Component({
    selector: 'g-row',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<ng-content></ng-content>`,
    styleUrls: [`./row.component.scss`]
})

export class RowComponent extends GridContainerClass {
    @HostBinding('class._wrap') @Input() wrap = false;
}
